import project1 from "../assets/project1.png";
import project2 from "../assets/project2.png";
import project3 from "../assets/project3.png";

const ProjectCardData = [
  {
    imgsrc: project1,
    title: "Disney+ Cloned Project",
    text: "The Disney landing page is a visually captivating and interactive website created using HTML, CSS, and JavaScript, providing an immersive experience filled with enchanting characters, captivating storytelling, and delightful entertainment.",
    view: "https://28d64u.csb.app/",
    source: "https://github.com/k1neeraj/Disney-Clone",
  },
  {
    imgsrc: project2,
    title: "Imdb Cloned Project",
    text: "The IMDb clone developed in React utilizes APIs to fetch and display comprehensive movie and TV show data, offering users a seamless browsing experience with accurate information, ratings, and reviews from the IMDb database.",
    view: "https://imdb-clone-bcf60d.netlify.app/",
    source: "https://github.com/k1neeraj/React-Projects/tree/main/2.%20Imdb%20Clone"
  },
  {
    imgsrc: project3,
    title: "Responsive React Website",
    text: "This dummy responsive website crafted in React is a versatile and adaptive platform designed to showcase the power of React's components and responsiveness, ensuring optimal user experience across various devices and screen sizes.",
    view: "https://responsivewebsite-254435.netlify.app/",
    source: "https://github.com/k1neeraj/React-Projects/tree/main/1.%20React%20Landing%20Page"
  },
];

export default ProjectCardData;
